export const enum SFCCHeader {
  ClientId = 'x-dw-client-id',
}

export interface ISfccProductSearchApiSettings {
  clientId: string;
  baseUrl: string;
}

export interface ISfccRepresentedProduct {
  id: string;
  link: string;
}

export interface ISfccSearchRefinementValue {
  hit_count: number;
  label: string;
  value: string;
}

export interface ISfccSearchRefinement {
  attribute_id: string;
  label: string;
  values: ISfccSearchRefinementValue[];
}

export interface ISfccSortingOption {
  id: string;
  label: string;
}

export interface ISfccSearchHit {
  hit_type: string;
  link: string;
  product_id: string;
  product_type: { item: boolean };
  represented_product: ISfccRepresentedProduct;
  product_name: string;
}

export interface ISfccSearchResult {
  count: number;
  hits: ISfccSearchHit[];
  next?: string;
  previous?: string;
  refinements: ISfccSearchRefinement[];
  selected_refinements: Record<string, string>;
  selected_sorting_option: string;
  sorting_options: ISfccSortingOption[];
  start: number;
  total: number;
}
